<template>
  <label class="button" role="button">
    <IconAdd v-if="!isUploading" class="add-icon" />

    <!-- 上传按钮文本 -->
    <div class="button-text" v-if="uploadButtonText !== '添加文件，转成云链'">
      {{ uploadButtonText }}
    </div>

    <!-- 动态文本动画效果 -->
    <div v-else class="text-container">
      <div>添加文件，</div>
      <div class="function-text-container" style="--s: 2">
        <div class="function-text">转成云链</div>
        <div class="function-text">转二维码</div>
        <div class="function-text">转成云链</div>
      </div>
    </div>

    <!-- 文件输入框 -->
    <input
      class="file-input"
      type="file"
      multiple="false"
      ref="inputFileElement"
      @click="handleButtonClick"
      @change="inputFileChanged"
    />
  </label>
</template>

<script setup>
import IconAdd from "@/components/icons/IconAdd.vue";
import Tracking from "@/model/tracking.js";
import { useUpload } from "@/composables";
import { useUserStore } from "@/store/userStore";
import { storeToRefs } from "pinia";

const userStore = useUserStore();
const { isLogin } = storeToRefs(userStore);

const {
  state: { uploadButtonText, inputFileElement, isUploading },
  action: { handleFileChange },
} = useUpload();

// 处理文件变化,只保留埋点逻辑
const inputFileChanged = async (event) => {
  Tracking.send({
    trigger: "file-selected",
    page: "main-page",
    extra: {
      file_number: event.target.files.length,
    },
    scene: isLogin.value ? "permanent" : "temporary",
  });
  await handleFileChange(event);
};

// 处理按钮点击,只保留埋点逻辑
const handleButtonClick = () => {
  Tracking.send({
    trigger: "button-click",
    page: "main-page",
    object: "add-file-button",
    scene: isLogin.value ? "permanent" : "temporary",
  });
};
</script>

<style scoped lang="scss">
.button {
  position: relative;
  transition: all 0.15s linear;
  cursor: pointer;
  width: px2rem(253);
  height: px2rem(54);
  margin-top: px2rem(71);
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 px2rem(4) px2rem(4) rgba(0, 0, 0, 0.16);
  opacity: 1;
  border-radius: px2rem(26);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: px2rem(22);

  $height: 3vh;
  $speed: 1s;
  $delay: 2s;
  $s: 2;

  .text-container {
    height: $height;
    line-height: $height;
    font-size: px2rem(17);
    color: #212121;
    font-family: "思源黑体 Medium";
    overflow: hidden;
    display: flex;

    .function-text-container {
      display: flex;
      flex-wrap: nowrap;
      flex-direction: column;
      animation: move calc(($speed + $delay) * $s) steps($s) infinite;

      .function-text {
        flex-shrink: 0;
        width: 100%;
        box-sizing: border-box;
        white-space: nowrap;
        cursor: pointer;
        animation: itemMove calc($speed + $delay) infinite;
      }
    }
  }

  @keyframes move {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(0, calc($s * $height * -1));
    }
  }

  @keyframes itemMove {
    0%,
    80% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(0, calc($height * -1));
    }
  }

  .add-icon {
    width: px2rem(16);
    height: px2rem(16);
    margin-right: px2rem(16);
  }

  .button-text {
    font-size: px2rem(17);
    color: #212121;
    font-family: "思源黑体 Medium";
  }

  .file-input {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  &:hover {
    @media screen and (min-width: 769px) {
      transition: all 0.15s linear;
      margin-left: 1vw;
    }
  }
}
</style>
